import brands from './creditCards'
import luhnCheck from './luhnCheck'
import exception from './exceptionCreditCards'

const validator = (number) => {
  const cleanNumber = number.replace(/\D/g, '')

  if (cleanNumber.length < 6) return false

  const brand = brands.find(({ regex }) => regex.test(cleanNumber))

  if (!brand) return false

  const hasValidLength = brand.size.includes(cleanNumber.length)
  const isValid =
    hasValidLength && (exception(cleanNumber) || luhnCheck(cleanNumber))

  return { ...brand, isValid }
}

export default validator
